import {
  getPaymentRequestedData,
  dgftCreditCardGenerateToken,
  dgftAuthorizePayment,
} from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { getLanguage } from '@kfc-global/kfc-i18n/lib/i18N';
import { PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import { redirectToPaymentFailurePage } from 'common/utilities/utils';

export const cartDataFields = data => {
  return data?.map((key, index) => {
    return (
      <>
        <input type='hidden' name={`name[${index}]`} value={`${key.item.name}`}></input>
        <input type='hidden' name={`quantity[${index}]`} value={`${key.quantity}`}></input>
        <input type='hidden' name={`price[${index}]`} value={`${key.amount / 100}`}></input>
      </>
    );
  });
};

export const dispatchPaymentRequest = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { dispatch } = checkoutDetails;
  if (checkoutDetails?.isClickAddPayment && checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.DGFT_CREDIT_CARD) {
    dispatch(
      getPaymentRequestedData(
        {
          tenantId: checkoutDetails?.tenantId,
          data: {
            orderId: checkoutDetails?.orderId,
            tenderType: checkoutDetails?.tender?.name,
          },
        },
        param => {
          updateCheckoutDetails({ DgftPaymentId: param?.paymentId, DgftTokenApiKey: param?.tokenApiKey });
          dispatchDgftTokenGeneration(props, param);
        },
        () => {
          redirectToPaymentFailurePage({ ...props });
        },
      ),
    );
  } else {
    dispatch(
      getPaymentRequestedData({
        tenantId: checkoutDetails?.tenantId,
        data: {
          orderId: checkoutDetails?.orderId,
          tenderType: checkoutDetails?.tender?.name,
        },
      }),
    );
  }
};

export const dispatchDgftTokenGeneration = (props, param) => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { dispatch } = checkoutDetails;
  checkoutDetails?.isClickAddPayment &&
    dispatch(
      dgftCreditCardGenerateToken(
        {
          data: {
            card_number: checkoutDetails?.paymentCardDetails?.cardNumber?.replace(/ /g, ''),
            card_expire: checkoutDetails?.paymentCardDetails?.cardExpDate?.replace(/ /g, ''),
            security_code: checkoutDetails?.paymentCardDetails?.cardCVV,
            cardholder_name: checkoutDetails?.paymentCardDetails?.cardHolderName,
            token_api_key: param?.tokenApiKey,
            lang: getLanguage()?.replace(/-JP/g, ''),
          },
        },
        response => {
          updateCheckoutDetails({ DgftTokenApiKey: response?.token });
          dispatchAuthorizePayment(props, param?.paymentId, response?.token);
        },
        () => {
          redirectToPaymentFailurePage({ ...props });
        },
      ),
    );
};

export const dispatchAuthorizePayment = (props, paymentId = null, tokenApiKey = null) => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { dispatch } = checkoutDetails;
  dispatch(
    dgftAuthorizePayment(
      {
        tenantId: checkoutDetails?.tenantId,
        paymentType: PAYMENT_TENDER_TYPES?.CREDIT_CARD,
        data: {
          orderId: checkoutDetails?.orderId,
          PaymentRefNumber: paymentId,
          token: tokenApiKey,
          total: checkoutDetails?.finalAmount,
          Accept: 'application/json',
          UserAgent: window?.navigator?.userAgent,
        },
      },
      response => {
        updateCheckoutDetails({
          DgftModalJs: /<SCRIPT.*?>([\s\S]*)<\/SCRIPT>/?.exec(response?.resResponseContents?.replace(/[\r\n]+/g, '')),
          DgftModalOpen: true,
          DgftresHtml: response?.resResponseContents?.replace(/[\r\n]+/g, ''),
        });
      },
      () => {
        redirectToPaymentFailurePage({ ...props });
      },
    ),
  );
};
